module.exports = __webpack_public_path__ + "static/img/patient_management_blue.d75d581.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/patient_management_blue.png
// module id = ChjA
// module chunks = 1